module.exports = __webpack_public_path__ + "static/media/step_img_03.37c4e22b.png";